import { LoadingButton } from '@mui/lab';

import Loader from '../Loader';

const Button = ({
  isLoading, children, className, size, ...props
}) => {
  return (
    <LoadingButton
      className={className}
      size={size}
      loading={isLoading}
      loadingIndicator={<Loader color="inherit" size={size === 'small' ? 20 : 30} />}
      {...props}
    >
      {children}
    </LoadingButton>
  );
};

export default Button;
